"use client";

import Script from "next/script";
import { useEffect, useState } from "react";

export default function HotjarScript() {
  const [shouldLoad, setShouldLoad] = useState(false);

  useEffect(() => {
    // Check if cookie consent was given
    const checkConsent = () => {
      if (document.cookie.includes("cookieConsent=true")) {
        setShouldLoad(true);
      }
    };

    // Check immediately
    checkConsent();

    // Also listen for cookie changes (in case consent is given after page load)
    const interval = setInterval(checkConsent, 1000);

    return () => clearInterval(interval);
  }, []);

  if (!shouldLoad) {
    return null;
  }

  return (
    <Script
      id="hotjar-tracking"
      strategy="afterInteractive"
      dangerouslySetInnerHTML={{
        __html: `
          (function(h,o,t,j,a,r){
            h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
            h._hjSettings={hjid:6599211,hjsv:6};
            a=o.getElementsByTagName('head')[0];
            r=o.createElement('script');r.async=1;
            r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
            a.appendChild(r);
          })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
        `,
      }}
    />
  );
}
